/**
 * Skala oštećenja za novu robu s defektima (brend, nekorišteno, ali s oštećenjem / nedostatkom).
 * 1 = najbolje stanje, 5 = najteže oštećenje.
 */
export type ProductConditionDef = {
  value: 1 | 2 | 3 | 4 | 5;
  /** Kružnica u admin izboru stanja */
  dotClass: string;
  /** Klasa za ConditionBadge (pozadina + tekst) */
  badgeClassName: string;
  /** Kratko za badge i tabelu (jedna riječ / fraza) */
  shortName: string;
  /** Puni opis za title / pomoć */
  description: string;
};

export const PRODUCT_CONDITIONS: ProductConditionDef[] = [
  {
    value: 1,
    dotClass: "bg-emerald-500",
    badgeClassName: "bg-emerald-100 text-emerald-700",
    shortName: "Najmanje",
    description:
      "Nova roba, gotovo savršena ili s minimalnim oštećenjem (npr. oštećena ambalaža, sitnica na etiketi).",
  },
  {
    value: 2,
    dotClass: "bg-emerald-400",
    badgeClassName: "bg-emerald-50 text-emerald-600",
    shortName: "Blago",
    description: "Blago oštećenje, slabo uočljivo, lokalizovano.",
  },
  {
    value: 3,
    dotClass: "bg-yellow-400",
    badgeClassName: "bg-yellow-50 text-yellow-700",
    shortName: "Umjereno",
    description: "Umjereno oštećenje, jasno vidljivo, ali ograničeno na područje.",
  },
  {
    value: 4,
    dotClass: "bg-orange-400",
    badgeClassName: "bg-orange-50 text-orange-600",
    shortName: "Izraženo",
    description: "Izraženo oštećenje, primjetno pri nošenju ili na prvi pogled.",
  },
  {
    value: 5,
    dotClass: "bg-red-500",
    badgeClassName: "bg-red-50 text-red-600",
    shortName: "Jako",
    description: "Jako oštećenje, značajan vizuelni ili funkcionalni nedostatak.",
  },
];

export function getProductCondition(
  value: number
): ProductConditionDef | undefined {
  if (value < 1 || value > 5) return undefined;
  return PRODUCT_CONDITIONS[value - 1];
}
